import { motion } from "framer-motion";
import { ABOUT_IMAGE } from "@/lib/site-data";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative grain py-24 lg:py-36 bg-cream">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="lg:col-span-5 relative"
                >
                    <div className="aspect-[4/5] overflow-hidden">
                        <img
                            src={ABOUT_IMAGE}
                            alt="Calm Thai spa room with candles"
                            className="w-full h-full object-cover"
                        />
                    </div>
                    {/* Gold frame accent */}
                    <div className="absolute -bottom-4 -right-4 w-32 h-32 border border-gold hidden md:block" />
                    <div className="absolute -top-4 -left-4 w-24 h-24 border border-maroon/30 hidden md:block" />
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8, delay: 0.15 }}
                    className="lg:col-span-7"
                >
                    <span className="eyebrow flex items-center gap-3">
                        <span className="w-8 h-px bg-gold" />
                        About Aekkarag
                    </span>
                    <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
                        A small sanctuary for{" "}
                        <em className="font-light text-gold-dark">true Thai wellness</em> in Cape Town.
                    </h2>

                    <div className="mt-8 space-y-5 text-base lg:text-lg text-ink-soft leading-relaxed font-light">
                        <p>
                            Aekkarag Thai Massage is a family-run wellness studio with two warm,
                            welcoming branches in Claremont and Wynberg. Every treatment is delivered by
                            <span className="text-maroon font-medium"> skilled Thai therapists</span>{" "}
                            trained in the traditional techniques carried through generations.
                        </p>
                        <p>
                            From deep, knot-releasing pressure to gentle aromatic oils, our work is
                            quiet, intentional and tailored to how your body feels that day. The
                            atmosphere is calm. The pace is slow. The care is honest.
                        </p>
                        <p className="text-maroon font-serif italic text-xl lg:text-2xl pt-2">
                            “Relax your body. Calm your mind. Walk out lighter.”
                        </p>
                    </div>

                    <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
                        <div>
                            <div className="font-serif text-3xl lg:text-4xl text-gold-dark">4,700+</div>
                            <div className="text-xs tracking-widest uppercase text-ink-muted mt-1">
                                Happy guests
                            </div>
                        </div>
                        <div>
                            <div className="font-serif text-3xl lg:text-4xl text-gold-dark">7</div>
                            <div className="text-xs tracking-widest uppercase text-ink-muted mt-1">
                                Signature therapies
                            </div>
                        </div>
                        <div>
                            <div className="font-serif text-3xl lg:text-4xl text-gold-dark">2</div>
                            <div className="text-xs tracking-widest uppercase text-ink-muted mt-1">
                                Cape Town branches
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
